/**
 * Session Item resource
 *
 * @name SessionItem
 * @class
 * @augments TmrResource
 */
export const factory = [
  'SessionItem',
  /*@ngInject*/ (TmrApi, TmrResource, Session, Parcel) => {
    let referencesProperties = [
      { property: 'parcel', resource: Parcel },
      { property: 'session', resource: Session },
    ]

    let SessionItem = TmrResource('SessionItem', referencesProperties)

    function getValue(code) {
      if (typeof code !== 'string') {
        throw new Error(
          'SessionItem.getValue(code) action requires a configuration key (code)'
        )
      }
      return TmrApi.get('SessionItem', { id: null }, { params: { code } }).then(
        res => (res.data.length ? res.data[0].value : null)
      )
    }

    Object.assign(SessionItem, { getValue })

    return SessionItem
  },
]
